<template>
<div>
  <HomeAltLayout isHome="true" bg_icon='fyiio'>
    <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
                <a href="http://www.fyi.io">
                  <img class='logo' src="./../../assets/fyiio-logo-with-name.svg" />
                </a>
          </div>
    </div>
    <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
               <div style="color:white;font-size:36px;padding-top: 15px !important" class="valign">check your email <br/> enter verification code</div>
               <div class="alert alert-danger" v-if="error">
                <p v-if="error" class="error">{{ error.message }}</p>
              </div>
          </div>
    </div>
    <br>
              <form @submit.prevent="confirm">
                <div class="row register-form smallzer">
                  <div class="center col s10 offset-s1 m4 offset-m6 " style="background-color:white;border-radius:5px">
                      <div class="input-field" style="height:30px">
                          <input id="username_inline" type="text"  class="fiedler form-control" v-model="username" required style="background:white">
                          <label for="username_inline" class="adjust-label">Email address</label>
                      </div>
                  </div>
                </div>
                <br>
                <div class="row register-form smallzer">
                  <div class="center col s10 offset-s1 m4 offset-m6" style="background-color:white;border-radius:5px">
                      <div class="input-field" style="height:30px">
                        <input id="registration_code_inline" type="text" class="fiedler form-control" v-model="code" required style="background:white">
                        <label for="registration_code_inline" class="adjust-label">Verification Code</label>
                      </div>
                  </div>
                </div>
                <br>
                <div class="row register-form smallzer">
                  <div class="col s12 m4 offset-m6 " :class="$mq === 'md'?'left':'center'">
                    <button class="btn blue" :style="$mq === 'md'?'position:relative; left:-10px':''" style="border-radius:20px;text-transform:none">Continue</button>
                  </div>
                </div>
                <div class="row register-form smallzer">
                  <div class=" col s12 m4 offset-m6 center" >
                    <p style="color:white">Didn’t get an email?
                    <router-link :to="{path: 'resend', query: {username: this.username}}"> &nbsp;Try sending another one.</router-link></p>
                  </div>
              </div>
             </form> 
             <div class="row marketing">
             </div>
          
  </HomeAltLayout>
  
</div>
</template>
<!-- Event snippet for account signup conversion page --> <script> gtag('event', 'conversion', {'send_to': 'AW-695760301/JXjrCKjN8tMBEK3r4csC'}); </script>
<script>
import HomeAltLayout from '@/containers/layouts/HomeAltLayout'
import MobileLayout from '@/containers/layouts/MobileLayout'
export default {
  mounted(){
  //  let hold=$('#bigz').removeClass('blue-bg').addClass('blueish-bg');
    //console.log("hold is:", hold)
  },
  data () {
    return {

      username: this.$route.query.username,
      code: '',
      error: null
    }
  },
  methods: {
    confirm () {
      this.$cognitoAuth.confirmRegistration(this.username, this.code, (err, result) => {
        if (err) {
          this.error = err
          console.error(err)
        } else {

          this.$router.replace({path: '/login', query: {confirmed: 'true', username: this.username}})
        }
      })
    }
  },
  components: {
    HomeAltLayout, MobileLayout
  }
}
</script>

<style scoped>


.mobileLayout {
  background-image: url('./../../assets/galaxy.png');
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/ConfirmAlt.vue